import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

/**
 * Displays a checkpoint name and optional form name, each with an appropriate icon.
 * Used as a consistent header across checkpoint-form screens
 * (form view, submission form, history, QR code).
 */
@Component({
  selector: 'app-checkpoint-form-header',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './checkpoint-form-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './checkpoint-form-header.component.css',
})
export class CheckpointFormHeaderComponent {
  @Input() checkpointName = '';
  @Input() formName: string | null | undefined = null;
  @Input() serialNumber: string | null | undefined = null;
}
